// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VFER","label":"styles_label__1anAQ"};